angular.module('property-deal')
    .controller('PropertyDealAssetChangePriceController', function ($uibModalInstance, data, Property, PropertyService, Principal, InvoiceService) {
        this.PropertyService = PropertyService
        this.$onInit = () => {
            this.limitUpPercent = 10.0;
            this.limitDownPercent = -2.8;

            this.item = {
                type: data.type,
                livingArea: data.property.livingArea,
                livingAreaFinal: data.property.livingAreaFinal,
                calculationMethod: data.calculationMethod,
                calculationBasedOn: data.calculationBasedOn,
                vat: data.vat,
                pricingBase: angular.copy(data.pricingBase),
                pricingAttributes: angular.copy(data.pricingAttributes),
                pricing: angular.copy(data.pricing),
                attributes: angular.copy(data.attributes),
                pricingRegular: data.pricingRegular ? angular.copy(data.pricingRegular) : angular.copy(data.pricing)
            }
            this.calculationMethods = Property.calculationMethods();
            this.canChangePriceNoLimit = Principal.hasAnyAuthority(["ROLE_PROPERTY_DEAL_PRICE_CHANGE_NO_LIMIT"])
        }

        this.discount = () => {
            let totalNetDiff = InvoiceService.sub(this.item.pricing.totalNet, this.item.pricingRegular.totalNet);
            let totalGrossDiff = InvoiceService.sub(this.item.pricing.totalGross, this.item.pricingRegular.totalGross);
            if(totalNetDiff === 0 && totalGrossDiff === 0) {
                return;
            }
            return {
                totalNet: totalNetDiff,
                totalGross: totalGrossDiff,
            }
        }

        this.priceDiff = () => {
            return InvoiceService.sub(this.item.pricing.totalGross, this.item.pricingRegular.totalGross);
        }

        this.currentPriceChangePercentage = () => {
            let sub = this.priceDiff();
            return InvoiceService.percentage(sub, this.item.pricingRegular.totalGross);
        }

        this.priceChangeLimitExceeded = () => {
            if(this.canChangePriceNoLimit)
                return false;

            let discountPercentage = this.currentPriceChangePercentage();
            return discountPercentage > this.limitUpPercent || discountPercentage < this.limitDownPercent;
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return $uibModalInstance.close(this.item);
        }
    })
    .controller('PropertyDealExtraChargeChangePriceController', function ($uibModalInstance, data, PropertyDeal, Property, PropertyService, Principal) {
        this.PropertyService = PropertyService
        this.$onInit = () => {
            this.item = {
                type: data.type,
                calculationMethod: data.calculationMethod,
                calculationBasedOn: 'TOTAL',
                vat: data.vat,
                pricing: angular.copy(data.pricing),
                pricingRegular: data.pricingRegular ? angular.copy(data.pricingRegular) : angular.copy(data.pricing)
            }
            this.calculationMethods = Property.calculationMethods();
            this.canChangePriceNoLimit = Principal.hasAnyAuthority(["ROLE_PROPERTY_DEAL_PRICE_CHANGE_NO_LIMIT"])
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return $uibModalInstance.close(this.item);
        }
    })
